import { Award, QrCode } from "lucide-react";
import { Logo } from "@/components/Logo";

const ROWS = [
  ["Material", "Chatarra de Aluminio 6063"],
  ["Cantidad valorizada", "10,0 t"],
  ["CO₂ eq. mitigado", "91,0 t CO₂e"],
  ["Destino", "Fundición secundaria · Maipú"],
];

export const CertificatePreview = () => (
  <div className="relative bg-white rounded-2xl shadow-2xl border border-slate-200 overflow-hidden rotate-[-1.5deg] hover:rotate-0 transition-transform duration-500" data-testid="esg-certificate-preview">
    <div className="bg-[#0a1f18] px-6 py-5 flex items-center justify-between">
      <Logo testId="certificate-logo" />
      <span className="font-mono text-[11px] text-slate-400">N° TL-2026-EJEMPLO</span>
    </div>
    <div className="p-6 space-y-5">
      <div className="flex items-start gap-3">
        <Award className="w-8 h-8 text-[#00c487] shrink-0" />
        <div>
          <p className="font-display font-bold text-lg text-[#05130e] leading-tight">Certificado de Valorización y Mitigación CO₂</p>
          <p className="text-xs text-slate-500 mt-1">Empresa ejemplo S.A. · Ley REP / Reporte ESG</p>
        </div>
      </div>
      <dl className="divide-y divide-slate-100 text-sm">
        {ROWS.map(([k, v]) => (
          <div key={k} className="flex justify-between py-2"><dt className="text-slate-500">{k}</dt><dd className="font-semibold text-[#05130e] text-right">{v}</dd></div>
        ))}
      </dl>
      <div className="flex items-center justify-between pt-2">
        <div className="h-1.5 w-28 rounded-full bg-[#00f2a1]" />
        <QrCode className="w-10 h-10 text-slate-300" />
      </div>
      <p className="text-[10px] text-slate-400 font-mono">Muestra ilustrativa</p>
    </div>
  </div>
);
